import { createApiSaga } from '../../sagaGenerator';
import {
  apiGet, apiPost, apiPut,
} from '../../../middleware/api';
import {
  GET_EDIT_REFERENCE_REQUEST,
  GET_EDIT_REFERENCE_SUCCESS,
  GET_EDIT_REFERENCE_FAILURE,
  UPDATE_EDIT_REFERENCE_REQUEST,
  UPDATE_EDIT_REFERENCE_SUCCESS,
  UPDATE_EDIT_REFERENCE_FAILURE,
  CREATE_EDIT_REFERENCE_REQUEST,
  CREATE_EDIT_REFERENCE_SUCCESS,
  CREATE_EDIT_REFERENCE_FAILURE,
  GET_EDIT_REFERENCE_HAVE_REQUEST,
  GET_EDIT_REFERENCE_HAVE_FAILURE,
  GET_EDIT_REFERENCE_HAVE_SUCCESS,
} from './referenceEditReducer';


const getReferenceSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}`, ...action }),
  requestType: GET_EDIT_REFERENCE_REQUEST,
  successType: GET_EDIT_REFERENCE_SUCCESS,
  failureType: GET_EDIT_REFERENCE_FAILURE,
});

const createReferenceSaga = createApiSaga({
  apiFunction: apiPost,
  generateApiConfig: action => ({ endpoint: '/references', ...action }),
  requestType: CREATE_EDIT_REFERENCE_REQUEST,
  successType: CREATE_EDIT_REFERENCE_SUCCESS,
  failureType: CREATE_EDIT_REFERENCE_FAILURE,
  successMessage: 'Saved',
});

const updateReferenceSaga = createApiSaga({
  apiFunction: apiPut,
  generateApiConfig: action => ({ endpoint: `/references/${action.id}`, ...action }),
  requestType: UPDATE_EDIT_REFERENCE_REQUEST,
  successType: UPDATE_EDIT_REFERENCE_SUCCESS,
  failureType: UPDATE_EDIT_REFERENCE_FAILURE,
  successMessage: 'Saved',
});

const getHavesSaga = createApiSaga({
  apiFunction: apiGet,
  generateApiConfig: action => ({ endpoint: '/descriptors/reference/have-values', ...action }),
  requestType: GET_EDIT_REFERENCE_HAVE_REQUEST,
  successType: GET_EDIT_REFERENCE_HAVE_SUCCESS,
  failureType: GET_EDIT_REFERENCE_HAVE_FAILURE,
});

export const referenceEditSagas = [
  getReferenceSaga,
  createReferenceSaga,
  updateReferenceSaga,
  getHavesSaga,
];
